import React, {useRef} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {defaultTheme} from '@ibibo/build-theme';

import * as S from './Amenities.styles';
import AmenitiesList from './AmenitiesList/AmenitiesList';

import {detailsNavigationIds} from '../../details.config';

import {
  isStaticDataLoading as isStaticDataLoadingSelectorFn,
  hotelsAmenitiesSelector,
  detailsStaticDataSelector,
  reviewRatingSelector
} from '../../selectors';

import AmenitiesIconSelector from '../../../../components/AmenitiesIconSelector';

import SingleTick from '../../../../../stories/Icons/SingleTick';
import AmenitiesDetailsLoader from '../../../../../stories/components/hotels/Loadingpage/AmenitiesDetailsLoader/AmenitiesDetailsLoader';

const AmenitiesWrapper = styled.div(
  props => `
    width: 100%;
    margin: 0 auto;
    max-width:120rem;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
  `,
);

const ListOfCategoryAmenities: React.FC<{data: string[]}> = ({data}) => {
  return (
    <S.AmenitiesListInner>
      {data.map((amenityName) => <li key={amenityName}><SingleTick marginRight="1rem"/>{amenityName}</li>)}
    </S.AmenitiesListInner>
  );
};

const Amenities = () => {
  const amenitiesRef = useRef(null);

  const amentiesData = useSelector(hotelsAmenitiesSelector);
  const {detailsHotelName} = useSelector(detailsStaticDataSelector);
  const {hotelReviewRating, numberOfReviews} = useSelector(reviewRatingSelector);

  const {all: amenitiesList, categorized: categorizedAmenitiesList} = amentiesData;

  const fourAmenitiesList = amenitiesList.slice(0, 3);

  const isStaticDataLoading = useSelector(isStaticDataLoadingSelectorFn);

  if (isStaticDataLoading) {
    return (
      <AmenitiesWrapper ref={amenitiesRef} id={detailsNavigationIds.amenities}>
        <AmenitiesDetailsLoader />
      </AmenitiesWrapper>
    );
  }

  if (!amenitiesList.length) {
    return null;
  }

  return (
    <S.DetailRoomAmenities id={detailsNavigationIds.amenities}>
      <S.DetailAmenitiesInnerWrap>
        <S.AmenitesHeadWrap>
          <S.AmenitesHeadText>Facilities of {detailsHotelName}</S.AmenitesHeadText>
          <S.AmenitiesHeadSubText>Over-all hotel facilities <span>rated {hotelReviewRating} by {numberOfReviews} guests</span></S.AmenitiesHeadSubText>
        </S.AmenitesHeadWrap>
        <S.AmenitiesDetailOuterWrap>
          <S.AmenitiesDetailInnerWrap>
            <S.AmenitesDetailHeadWrap>
              <S.AmenitiesDetailHeadList>
                {fourAmenitiesList.map((amenityName) => 
                  <li key={amenityName}>
                    <AmenitiesIconSelector name={amenityName} styleProps={AmenityIconProps} />
                    {amenityName}
                  </li>)}
              </S.AmenitiesDetailHeadList>
            </S.AmenitesDetailHeadWrap>

            <S.AmenitiesListInnerWrap>
              <S.AmenitiesBlockWrap>
                <AmenitiesList columns={4} gap={20}>
                  {
                    categorizedAmenitiesList.map((category) => {
                      return (
                        <S.ListOuterWrapDiv key={category.label}>
                          <S.AmenitiesTypeHeadText>{category.label}</S.AmenitiesTypeHeadText>
                          <ListOfCategoryAmenities data={category.data} />
                        </S.ListOuterWrapDiv>
                      )
                    })
                  }
                </AmenitiesList>
              </S.AmenitiesBlockWrap>
            </S.AmenitiesListInnerWrap>
          </S.AmenitiesDetailInnerWrap>
        </S.AmenitiesDetailOuterWrap>
      </S.DetailAmenitiesInnerWrap>
    </S.DetailRoomAmenities>
  );
};

export default Amenities;

const AmenityIconProps = {
  width: '2.5rem',
  height: '2.5rem',
  margin: '0 0.5rem 0 0',
  fill: defaultTheme.colors.grey.base
}
